import {
  ParticipantDocumentStatus,
  renderParticipantDocumentStatus,
} from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';

export const participantDocumentStatusColorName = (status: ParticipantDocumentStatus) => {
  const rendered = renderParticipantDocumentStatus(status);
  switch (status) {
    case ParticipantDocumentStatus.Draft:
      return ['blue', rendered];
    case ParticipantDocumentStatus.Finalized:
      return ['green', rendered];
  }
};

interface Props extends ChakraV3.TagProps {
  status: ParticipantDocumentStatus;
}

export const ParticipantDocumentStatusTag = (props: Props) => {
  const { status, ...rest } = props;

  const [color, label] = participantDocumentStatusColorName(status);

  return (
    <ChakraV3.Tag size='sm' colorPalette={color} {...rest}>
      {label}
    </ChakraV3.Tag>
  );
};
